import 'intl';
import 'intl/locale-data/jsonp/en-SE';
import 'intl/locale-data/jsonp/da-DK';
import 'intl/locale-data/jsonp/nb-NO';
import 'intl/locale-data/jsonp/fi-FI';
import 'intl/locale-data/jsonp/en-US';
